module.exports = __webpack_public_path__ + "static/elPoder-fee80062becac45d9869e4c1ad107fde.png";